import { useGet } from 'hooks/use-get';
import React, { useContext } from 'react';

import { getAerators } from '../api/get-aerators';
import { useAccountState } from 'contexts/account/account-context';
import { Aerator } from 'views/self-service/features/aerators/types/aerators.type';

type State = {
  isLoading: boolean;
  aerators: Aerator[] | undefined;
};

const AeratorsContext = React.createContext<State | undefined>(undefined);

type AeratorsProviderProps = {
  children: React.ReactNode;
};

const AeratorsProvider: React.FC<AeratorsProviderProps> = ({ children }) => {
  const { account } = useAccountState();

  const { data: aerators, isLoading } = useGet(['getAerators'], () => getAerators(String(account.company!.companyId)), {
    enabled: !!account.company!.companyId,
  });

  return <AeratorsContext.Provider value={{ aerators, isLoading }}>{children}</AeratorsContext.Provider>;
};

function useAeratorsState() {
  const context = useContext(AeratorsContext);
  if (context === undefined) {
    throw new Error('useAeratorsState must be used within a Aerators provider');
  }
  return context;
}

export { AeratorsProvider, useAeratorsState };
